import Vue from "vue";
import Router from "vue-router";

import store from "@/store";

// Language / Localization
import LanguageService from "@/common/language.service";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			name: "Home",
			component: () => import("../views/Home.vue"),
			props: true
		},
		{
			path: "/order/:orderId",
			name: "Order",
			component: () => import("../views/Order.vue"),
			props: true
		},
		{
			path: "/online",
			name: "Online",
			component: () => import("../views/Online.vue"),
			props: true
		},
		{
			path: "/error",
			name: "Error",
			component: () => import("../views/Error.vue"),
			props: true
		},
		{
			path: "/warning",
			name: "Warning",
			component: () => import("../views/Warning.vue"),
			props: true
		},
		{
			path: "/pay/:details",
			name: "Pay",
			component: () => import("../views/Pay.vue"),
			props: true
		},
		{
			path: "*",
			redirect: "/",
			name: "404"
		}

	]
});
router.beforeEach((to, from, next) => {
	/* On route load, set document title to Merchant Name*/
	document.title = store.getters.merchant.Merchant + " | "+LanguageService.getText("HeaderText");
	//document.title = store.getters.merchant.Merchant + " | "+store.getters.merchant.HeaderText;
	next();
});
export default router;
